import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "numeric-quarter-table__column" }
const _hoisted_2 = { class: "numeric-quarter-table__column-label text text--center text--h3" }
const _hoisted_3 = { class: "numeric-quarter-table__column-row numeric-quarter-table__column-row--extra-padding" }
const _hoisted_4 = { class: "numeric-quarter-table__content" }
const _hoisted_5 = { class: "numeric-quarter-table__column-row numeric-quarter-table__column-row--padding" }
const _hoisted_6 = { class: "numeric-quarter-table__content" }
const _hoisted_7 = { class: "numeric-quarter-table__content-label" }
const _hoisted_8 = { class: "numeric-quarter-table__content" }
const _hoisted_9 = { class: "numeric-quarter-table__content-label" }
const _hoisted_10 = { class: "numeric-quarter-table__column-row" }
const _hoisted_11 = {
  key: 0,
  class: "numeric-quarter-table__content--button numeric-quarter-table__content--center"
}
const _hoisted_12 = { class: "numeric-quarter-table__content-text text text--h7 text--success" }

import EditSvg from '../assets/edit.svg';
import CompletedSvg from '../assets/completed.svg';

// Components
import VInput from './VInput.vue';
import VButton from './VButton.vue';

// Other
import { useI18n } from 'vue-i18n';
import { PropType } from 'vue';
import { INumericQuarterCompletion } from '@/mixins/NumericApi';
import QuarterNumber from '@/core/Values/QuarterNumber';
import NumericViewMode from '@/core/Values/NumericViewMode';


export default /*@__PURE__*/_defineComponent({
  __name: 'VNumericQuarterTableColumn',
  props: {
    committed: { type: Boolean, required: true },
    quarter: { type: Number as PropType<QuarterNumber>, required: true },
    quarterCompletion: { type: Object as PropType<INumericQuarterCompletion>, required: true },
    actualValue: { type: Number, default: 0 },
    expectedValue: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
    canUpdatePublicFields: { type: Boolean, default: false },
    canUpdatePrivateFields: { type: Boolean, default: false },
    viewMode: { type: Number as PropType<NumericViewMode>, default: NumericViewMode.Proportion },
},
  setup(__props) {

// Svg
const { t } = useI18n();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('quarter' + __props.quarter)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: _normalizeClass(["numeric-quarter-table__content-text text text--blurry text--h2", {
                        'text--warning': __props.quarterCompletion.warning,
                        'text--success': __props.quarterCompletion.success,
                        'text--negative': __props.quarterCompletion.negative,
                    }])
        }, [
          _createTextVNode(_toDisplayString(__props.quarterCompletion.value) + " ", 1),
          (_openBlock(), _createBlock(_resolveDynamicComponent(__props.quarterCompletion.icon), { class: "numeric-quarter-table__content-icon numeric-quarter-table__content-icon--fluid svg svg--125" }))
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('numeric.expected-value')), 1),
        _createVNode(VInput, {
          class: "numeric-quarter-table__input input-field--primary input-field--text-center",
          "concurrency-mode": "",
          "debounce-mode": "",
          disabled: !__props.canUpdatePrivateFields || __props.disabled || __props.committed,
          "format-percent": __props.viewMode === _unref(NumericViewMode).Percent,
          "model-value": __props.expectedValue,
          numeric: "",
          placeholder: _unref(t)('default-placeholder', 0),
          "round-decimals": "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:expected-value', $event)))
        }, null, 8, ["disabled", "format-percent", "model-value", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('numeric.actual-value')), 1),
        _createVNode(VInput, {
          class: "numeric-quarter-table__input input-field--primary input-field--text-center",
          disabled: "",
          "format-percent": __props.viewMode === _unref(NumericViewMode).Percent,
          "model-value": __props.actualValue,
          numeric: "",
          placeholder: _unref(t)('default-placeholder', 0),
          "round-decimals": ""
        }, null, 8, ["format-percent", "model-value", "placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (__props.committed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_unref(CompletedSvg), { class: "svg svg--125" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)('numeric.value-committed')), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(VButton, {
              class: "button--primary button--rounded-no-padding button--green button--fluid button--center",
              disabled: !__props.quarterCompletion.waiting || __props.committed || !__props.canUpdatePublicFields || __props.disabled,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('commit-value')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('numeric.commit-value')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(VButton, {
              class: "button--primary button--square-225 button--rounded-no-padding button--center button--default",
              disabled: !__props.quarterCompletion.waiting || !__props.canUpdatePublicFields || __props.committed || __props.disabled,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('add-value')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(EditSvg))
              ]),
              _: 1
            }, 8, ["disabled"])
          ], 64))
    ])
  ]))
}
}

})